import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../utils/api';

const useCostingData = ({ preloadedData, setPreloadedData, dataLoaded, setDataLoaded }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            if ((dataLoaded && preloadedData && preloadedData.length > 0) || loading) return;

            setLoading(true);
            setError(null);

            try {
                const res = await authenticatedFetch('/ManagerReport/GetCostingSummaryData', {
                    method: 'POST',
                    body: JSON.stringify({}),
                });

                const result = await res.json();

                if (result.item2 === null && result.item1) {
                    setPreloadedData(result.item1);
                    setDataLoaded(true);
                } else if (result.message) {
                    setError(result.message);
                }
            } catch (ex) {
                console.error('Failed to load costing summary data:', ex);
                setError('Failed to load data. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [dataLoaded, preloadedData, loading, setPreloadedData, setDataLoaded]);

    return { loading, error };
};

export default useCostingData;
